// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import cookies from 'js-cookie'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import App from './App'
import router from './router'
import {asyncRoutes} from './router/routers'
import {
  isPcOrMobile
} from './utils/utils'
import './icons'
// console.log(isPcOrMobile()) // icon
import {
  Button
} from 'vant'
import 'vant/lib/index.css'
import 'lib-flexible'
Vue.use(Button)
Vue.config.productionTip = false

// 进度条配置
NProgress.configure({showSpinner: false})

Vue.use(ElementUI)
Vue.use(VueAxios, axios)

const whiteList = ['/login', '/register', '/forgot-passwd', '/index', '/market', '/desktop', '/aboutus', '/mindex', '/mmarket', '/mdestop', '/maboutus']

// 校验是否登陆  只要路由跳转，刷新   进行加载
router.beforeEach((to, from, next) => {
  // 进度条开始
  NProgress.start()
  // 获取cookie中缓存的用户信息
  console.log(to.path)
  let token = cookies.get('userInfo')
  if (token === undefined) {
    if (to.path === '/' || to.path === '') {
      if (isPcOrMobile()) {
        next({
          path: '/mindex'
        })
      } else {
        next({
          path: '/index'
        })
      }
      // 完成进度条
      NProgress.done()
    } else {
      // 未登录的情况下
      if (whiteList.indexOf(to.path) !== -1 || to.path.substr(0, 3) === '/s/') {
        next()
      } else {
        // 其他无页面路由会返回上级路由
        if (to.path === '/ljfirmware') {
          next({path: from.fullPath})
        } else if (to.path === '/ljmange') {
          next({path: from.fullPath})
        } else if (to.path === '/rom-list') {
          // 判断是否为开发者位置点击进入 隐藏rom
          next({path: '/login', query: {isDeveloper: 1}})
          // next({path: '/login', query: {isDeveloper: 0}})
        } else if (to.path === '/group-list') {
          // 判断是否为管理分组位置点击进入
          next({path: '/login', query: {isDeveloper: 0}})
        } else {
          // 其他没有访问权限的页面被重定向到登录页面。
          next({path: '/login'})
        }
        // 完成进度条
        NProgress.done()
      }
    }
  } else {
    // 如果已登录，则重定向到主页
    // next({
    //   path: '/home'
    // })
    if (to.path === '/login') {
      if (isPcOrMobile()) {
        next({
          path: '/mindex'
        })
      } else {
        next({
          path: '/index'
        })
      }
      // 完成进度条
      NProgress.done()
    } else {
      if (to.path === '/rom-list') {
        localStorage.setItem('isDeveloper', 1)
        // 隐藏rom
        // localStorage.setItem('isDeveloper', 0)
      } else if (to.path === '/group-list') {
        localStorage.setItem('isDeveloper', 0)
      } else if (to.path === '/404') {
        next({path: '/index'})
      }
      next()
    }
  }
})

router.afterEach(() => {
  // 完成进度条
  NProgress.done()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  // 创建时触发
  created: function () {
    // 获取cookie中缓存的用户信息
    let token = cookies.get('userInfo')
    if (token !== undefined) {
      // 跳转404
      this.$router.addRoutes(asyncRoutes.concat([{
        path: '*',
        redirect: '/404'
      }]))
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js